import api from ".";
import { benchmarkRequestEndpoints } from "./endpoints/benchmarkRequest.endpoints";

export const benchmarkRequestApis = {
  searchCompanies: async (query, limit = 12) => {
    const res = await api.get(benchmarkRequestEndpoints.searchCompanies, {
      params: { q: query, limit },
    });
    return res.data?.companies || [];
  },

  create: async (payload) => {
    const res = await api.post(benchmarkRequestEndpoints.create, payload);
    return res.data;
  },

  listMine: async () => {
    const res = await api.get(benchmarkRequestEndpoints.mine);
    return res.data?.requests || [];
  },
};
